const generateUnsplashBackLink = (link) => {
  const appName = 'yolacom';
  return `${link}?utm_source=${appName}&utm_medium=referral`;
};

export default generateUnsplashBackLink;
